import React from "react";
import PropTypes from "prop-types";

function PageSimple({ num, currentPage, onSelect }) {
  const cl = "tw-select-none tw-flex tw-items-center tw-mx-2 tw-justify-center";

  return num === currentPage ? (
    <div className={`${cl} tw-text-primary`}>{num}</div>
  ) : (
    <div
      onClick={() => onSelect(num)}
      tabIndex={-1}
      className={`tw-cursor-pointer ${cl}`}
    >
      {num}
    </div>
  );
}

PageSimple.propTypes = {
  num: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default PageSimple;
